<div class="ps-container">
  <mat-card class="ps-card">
  <mat-card-title>Project Scheduler<span *ngIf="project"> — {{project.name || project.title || project.id}}</span></mat-card-title>
    <mat-card-content>
      <div class="ps-top">
        <div class="month-controls">
          <button mat-button (click)="prevMonth()">‹</button>
          <div class="month-title">{{visibleMonth | date:'MMMM yyyy'}}</div>
          <button mat-button (click)="nextMonth()">›</button>
          <button mat-stroked-button (click)="importSample()">Import Sample</button>
        </div>
        <div class="day-controls">
          <button mat-button (click)="prevDay()">‹ Prev</button>
          <input type="date" [(ngModel)]="selectedDate" name="datePicker" />
          <button mat-button (click)="nextDay()">Next ›</button>
        </div>
      </div>

      <div class="month-grid">
        <div class="week-headers">
          <div *ngFor="let h of ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']" class="week-h">{{h}}</div>
        </div>
        <div class="cells">
          <div *ngFor="let c of getMonthGrid()" class="cell" [class.outside]="!c.inMonth" (click)="selectDate(c.dateStr)">
            <div class="day-num">{{c.date.getDate()}}</div>
            <div class="cell-events">
              <div *ngFor="let e of c.events | slice:0:3" class="evt" [title]="e.title">{{e.title}}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="ps-grid">
        <div class="ps-list">
          <h3>Appointments for {{selectedDate}}</h3>
          <div *ngIf="filtered.length === 0" class="no-appointments">No appointments for this date.</div>
          <mat-list>
            <mat-list-item *ngFor="let a of filtered" class="appt-item" style="margin-bottom: 20px;">
                <div class="appt-time">{{ getDisplayTime(a) }}</div>
              <div class="appt-main">
                <div class="appt-title">{{a.title}}</div>
                <div class="appt-desc">Start Time: {{a.startTime | date:'short'}}{{a.endTime && a.endTime !== a.startTime ? ' — End Time: ' + (a.endTime | date:'short') : ''}} • {{a.description}}</div>
              </div>
              <div class="appt-actions">
                <button mat-mini-button color="primary" (click)="edit(a)">Edit</button>
                <button mat-mini-button color="warn" (click)="remove(a.id)">Delete</button>
              </div>
            </mat-list-item>
          </mat-list>
        </div>

        <div class="ps-form">
          <h3>{{form.id ? 'Edit' : 'Add'}} appointment</h3>
          <form (ngSubmit)="addOrUpdate()">
            <mat-form-field class="full">
              <mat-label>Start Date & Time</mat-label>
              <input matInput type="datetime-local" [(ngModel)]="form.startTime" name="fstart" />
            </mat-form-field>

            <mat-form-field class="full">
              <mat-label>End Date & Time</mat-label>
              <input matInput type="datetime-local" [(ngModel)]="form.endTime" name="fend" />
            </mat-form-field>

            <mat-form-field class="full">
              <input matInput placeholder="Title" [(ngModel)]="form.title" name="ftitle" />
            </mat-form-field>

            <mat-form-field class="full">
              <textarea matInput placeholder="Description" [(ngModel)]="form.description" name="fdesc"></textarea>
            </mat-form-field>

            <div class="form-actions">
              <button mat-raised-button color="primary" type="submit">{{form.id ? 'Update' : 'Add'}}</button>
              <button mat-button type="button" (click)="startNewFor(selectedDate)">Clear</button>
            </div>
          </form>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
